import { defineComponent as _defineComponent } from 'vue'

const __default__ = {}

import { __ } from '@@/bits/intl'
import { processedUrl } from '@padlet/vivaldi-client'
import { computed, ref } from 'vue'
import { ANONYMOUS_AVATAR } from '@@/bits/user_model'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'OzAvatar',
  props: {
    width: { default: undefined },
    height: { default: undefined },
    src: { default: null },
    fallbackSrc: { default: ANONYMOUS_AVATAR },
    altTextName: { default: 'anonymous' }
  },
  setup(__props: any) {

const props = __props as { width: number, height: number, src: string | null, fallbackSrc: string, altTextName: string }



const isErrored = ref(false)

const processedSrc = computed(() => {
  if (!props.src || isErrored.value) return props.fallbackSrc

  // for relative urls e.g. when developing locally
  if (props.src.startsWith('/')) return props.src

  return processedUrl(props.src, transforms.value)
})

const altText = computed(() => __('Avatar of %{name}', { name: props.altTextName }))

const transforms = computed(() => {
  if (props.width && props.height) {
    return {
      width: props.width,
      height: props.height,
      preset: 'avatar',
    }
  }
  return {
    preset: 'avatar',
  }
})

return { __sfc: true,props, isErrored, processedSrc, altText, transforms }
}

})